module.exports = __webpack_public_path__ + "img/icon8.05ffea2b.png";